import { mapGetters } from 'vuex'
import types from '../store/types'

const bottomNav = {
    computed: {
        ...mapGetters({
            scrolled: types.appState.getters.isScrolled
        })
    }
}

export default bottomNav
